export default "__VITE_ASSET__BKRmwzst__"